import React, { useState } from 'react';
import { X, Copy, Facebook, Twitter, Apple as WhatsApp, Mail, Check, Link } from 'lucide-react';

interface ShareProductModalProps {
  productName: string;
  productUrl: string;
  onClose: () => void;
}

const ShareProductModal: React.FC<ShareProductModalProps> = ({ productName, productUrl, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(productUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const shareOptions = [
    {
      name: 'Facebook',
      icon: <Facebook size={20} className="text-blue-600" />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}&quote=${encodeURIComponent(`Kolla in ${productName} på festutrustning.se!`)}`,
      color: 'bg-blue-50 hover:bg-blue-100'
    },
    {
      name: 'Twitter',
      icon: <Twitter size={20} className="text-blue-400" />,
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(productUrl)}&text=${encodeURIComponent(`Kolla in ${productName} på festutrustning.se!`)}`,
      color: 'bg-blue-50 hover:bg-blue-100'
    },
    {
      name: 'WhatsApp',
      icon: <WhatsApp size={20} className="text-green-600" />,
      url: `https://wa.me/?text=${encodeURIComponent(`Kolla in ${productName} på festutrustning.se! ${productUrl}`)}`,
      color: 'bg-green-50 hover:bg-green-100'
    },
    {
      name: 'E-post',
      icon: <Mail size={20} className="text-gray-600" />,
      url: `mailto:?subject=${encodeURIComponent(`Festutrustning: ${productName}`)}&body=${encodeURIComponent(`Hej!\n\nJag hittade denna produkt på festutrustning.se och tänkte att den kunde vara intressant för dig:\n\n${productName}\n${productUrl}\n\nHälsningar`)}`,
      color: 'bg-gray-50 hover:bg-gray-100'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-none max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Dela produkt</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-2">Dela {productName} med andra:</p>
          <div className="flex items-center border rounded-none overflow-hidden">
            <div className="bg-gray-50 p-3 border-r">
              <Link size={18} className="text-gray-500" />
            </div>
            <input
              type="text"
              value={productUrl}
              readOnly
              className="flex-1 p-3 outline-none text-sm"
            />
            <button
              onClick={handleCopyLink}
              className="p-3 bg-purple-600 hover:bg-purple-700 text-white transition-colors"
              title="Kopiera länk"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {shareOptions.map((option) => (
            <a
              key={option.name}
              href={option.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center p-4 rounded-none ${option.color} transition-colors`}
            >
              <div className="mr-3">{option.icon}</div>
              <span className="font-medium">{option.name}</span>
            </a>
          ))}
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800 font-medium"
          >
            Stäng
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareProductModal;